import moment from "moment/moment";

export default class Recu {
  public horodatage: number = -1;
  public dateFiscale: number = new Date().getTime();
  public libSite: string = "";
  public etat: string = "Manquant";
  public restaurantId: number = 0;
  public type: string = "MISSING";
  public tiroirReglements: any[] = new Array();
  public commentaire?: string = "";
  public reel: number = 0;
  public theo: number = 0;
  public diff: number = 0;
  public validationHorodatage: number = 0;
  public validationResponsableCode: number = 0;
  public validationResponsable: string = "";
  public id: number = 0;
  public order: number = -1;
  public complements = new Array();

  public makeMissing(
    date: string,
    libSite: string,
    restuarantid: number,
    id: number
  ) {
    // console.log(date);
    this.validationHorodatage = moment(date, "YYYY-MM-DD")
      .hour(0)
      .minute(0)
      .valueOf();
    // console.log(moment(this.validationHorodatage));
    this.horodatage = this.validationHorodatage;
    this.dateFiscale = this.validationHorodatage;
    this.libSite = libSite;
    this.restaurantId = restuarantid;
    this.id = id;
    this.etat = "Manquant";
    this.order = 1;
  }
}
